export default function getUidFromURL(): string {
    const pathname = (typeof location !== "undefined" && location.pathname) || "";
    const parts = pathname.split("/");
    const uid = parts[parts.length - 1];
    return uid;
}
